<template>
  <div id="app">
    <app-header sistema="Vigilância em Saúde" :usuario="usuario.nome" :unidade="usuario.unidade" />

    <main>
      <router-view/>
    </main>

    <app-footer />
  </div>
</template>

<script>
import AppHeader from './components/shared/header/AppHeader.vue'
import AppFooter from './components/shared/footer/AppFooter.vue'

export default {
    components: {
        AppHeader,
        AppFooter
    },
    created () {
        console.log(':)');
        // this.$store.dispatch('sessao/navbar')
    },
    computed: {
        loading() {
            return this.$store.getters['sessao/getLoading']
        },
        usuario() {
            return this.$store.getters['sessao/getUsuario']
        }
    },
}
</script>

<style>
#app {
  min-height: 100vh;
  min-width: 100%;
  display: flex;
  flex-direction: column;
}

main {
  flex-grow: 1;
}

header {
  margin-bottom: 1.6rem;
}
</style>